import React from "react";
import { Helmet } from "react-helmet-async";
import { Col, Container, Row } from "react-bootstrap";
import whyWerentt from "../assets/images/why-werentt.png";
import whyWerentt2 from "../assets/images/why-werentt-2.png";
import Keyflaws from "../assets/images/key-flaws.png";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLayerGroup,
  faTags,
  faIndianRupeeSign,
  faPuzzlePiece,
  faFlagCheckered,
  faCalendarCheck,
  faMoneyBillWave,
  faCogs,
  faBalanceScale,
  faFileAlt,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

export default function Whywerentt() {
  return (
    <div>
      <Helmet>
        <title>About Us - WeRentt</title>

        {/* Meta SEO */}
        <meta
          name="description"
          content="Learn more about WeRentt, your trusted partner in property management, offering comprehensive solutions for both property owners and tenants in the city."
        />
        <meta
          name="keywords"
          content="WeRentt, property management, rental solutions, leasing services, tenant support"
        />
      </Helmet>
      <section className="custom-breadcrumb">
        <Container>
          <Row>
            <Col sm={12}>
              <ul className="bread-crumb-list">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="#">Why Werentt</Link>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="why-werentt-section section">
        <Container>
          <Row>
            <Col md={6}>
              <div className="img-block">
                <img
                  src={whyWerentt2}
                  alt="Why werentt for buy sell and rent property"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="why-werent-contnet section-heading">
                <h2 className="mb-2">
                  {" "}
                  Why WeRentt for{" "}
                  <span className="pink-text"> Buying / Selling </span> Property
                </h2>
                <p>
                  Werentt is the first and only property portal in India to
                  implement{" "}
                  <strong>fixed fee model for buying and selling </strong>{" "}
                  properties. We implement a transparent alternative to the
                  standard 1%–2%-5% commission typically paid by both buyers and
                  sellers.
                </p>
                <h3 className="text-black mt-3">Fixed-Fee Strategies</h3>
                <ul className="werentt-feature-list">
                  <li>
                    <FontAwesomeIcon icon={faLayerGroup} />
                    <div>
                      <h4>Tiered Service Packages:</h4>
                      <p>
                        “Platinum”, "Gold," and "Silver" based on the level of
                        support.
                        <br />
                        <b>Basic Tier:</b>Includes essential listings, automated
                        marketing, and basic advisory.
                        <br />
                        <b>Premium Tier:</b>Adds professional photography,
                        assisted site visits.
                      </p>
                    </div>
                  </li>

                  <li>
                    <FontAwesomeIcon icon={faTags} />
                    <div>
                      <h4>Slab-Based Fixed Fees:</h4>
                      <p>
                        We accommodate varying property values in Bengaluru
                        (from ₹25 lakh plots to ₹5+ crore luxury flats).
                      </p>
                    </div>
                  </li>

                  {/* <li>
    <FontAwesomeIcon icon={faIndianRupeeSign} />
    <div>
      <h4>Base Fixed Price:</h4>
      <p>
        ₹75,000 for properties under ₹1 crore, ₹1,50,000 for ₹1–3 crore, ₹2,50,000 for ₹3-5 crore.
        <br></br> ₹3,50,000 for properties over ₹5 – 7.5 crore and ₹5,00,000 for properties over ₹7.5+crore.
      </p>
    </div>
  </li>

  <li>
    <FontAwesomeIcon icon={faPuzzlePiece} />
   
    <div>
      <h4>A-la-Carte Add-ons:</h4>
      <p>
        we charge additional fixed prices for high-value manual services assisting - legal drafting, or "e-Khatha" assistance.
      </p>
    </div>
  </li>

  <li>
    <FontAwesomeIcon icon={faFlagCheckered} />
    <div>
        
      <h4>Milestone Based Payment Model:</h4>
      <p>
        The fixed fee is collected upon each completion of each milestone and final payment on successful property registration.
      </p>
    </div>
  </li>

  <li>
    <FontAwesomeIcon icon={faCalendarCheck} />
    <div>
        
      <h4>Subscription Model for Frequent Sellers:</h4>
      <p>
        Our subscription fee is fixed <strong>24k </strong>per annum.
      </p>
    </div>
  </li> */}
                </ul>
              </div>
            </Col>
            <Col md={12}>
              <ul className="werentt-feature-list grid-of-2 mt-4">
                <li>
                  <div className="icon-box">
                    <FontAwesomeIcon icon={faIndianRupeeSign} />
                  </div>
                  <div>
                    <h4>Base Fixed Price:</h4>
                    <p>
                      ₹75,000 for properties under ₹1 crore, ₹1,50,000 for ₹1–3
                      crore, ₹2,50,000 for ₹3-5 crore. ₹3,50,000 for properties
                      over ₹5 – 7.5 crore and ₹5,00,000 for properties over
                      ₹7.5+crore.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="icon-box">
                    <FontAwesomeIcon icon={faPuzzlePiece} />
                  </div>

                  <div>
                    <h4>A-la-Carte Add-ons:</h4>
                    <p>
                      we charge additional fixed prices for high-value manual
                      services assisting - legal drafting, or "e-Khatha"
                      assistance.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="icon-box">
                    <FontAwesomeIcon icon={faFlagCheckered} />
                  </div>
                  <div>
                    <h4>Milestone Based Payment Model:</h4>
                    <p>
                      The fixed fee is collected upon each completion of each
                      milestone and final payment on successful property
                      registration.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="icon-box">
                    <FontAwesomeIcon icon={faCalendarCheck} />
                  </div>
                  <div>
                    <h4>Subscription Model for Frequent Sellers:</h4>
                    <p>
                      Our subscription fee is fixed <strong>24k </strong>per
                      annum.
                    </p>
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="key-benifits-section section">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="section-heading">
                <h2>Key Benefits to Our Clients</h2>
              </div>
            </Col>
          </Row>
          <div className="key-benefits-contnet-wrap">
            <Row>
              <Col md={3} sm={12} className="mb-4">
                <div className="key-benifit-box custom-card">
                  <div className="key-benifits-icon">
                    <FontAwesomeIcon icon={faMoneyBillWave} />
                  </div>
                  <div className="key-benifits-content">
                    <h3>Cost Certainty</h3>
                    <p>
                      Markets the model as "Zero Brokerage" with a transparent,
                      one-time service fee to appeal to budget-conscious buyers.
                    </p>
                  </div>
                </div>
              </Col>
              <Col md={3} sm={12} className="mb-4">
                <div className="key-benifit-box custom-card">
                  <div className="key-benifits-icon">
                    <FontAwesomeIcon icon={faCogs} />
                  </div>
                  <div className="key-benifits-content">
                    <h3>Operational Efficiency</h3>
                    <p>
                      Uses automated tools on the Kaveri 2.0 portal for digital
                      document verification to keep overheads low enough for a
                      fixed-fee model.
                    </p>
                  </div>
                </div>
              </Col>
              <Col md={3} sm={12} className="mb-4">
                <div className="key-benifit-box custom-card">
                  <div className="key-benifits-icon">
                    <FontAwesomeIcon icon={faBalanceScale} />
                  </div>
                  <div className="key-benifits-content">
                    <h3>RERA Compliance</h3>
                    <p>
                      Ensure all fee structures and agent details are
                      transparent and compliant with Karnataka RERA guidelines.
                    </p>
                  </div>
                </div>
              </Col>
              <Col md={3} sm={12} className="mb-4">
                <div className="key-benifit-box custom-card">
                  <div className="key-benifits-icon">
                    <FontAwesomeIcon icon={faFileAlt} />
                  </div>
                  <div className="key-benifits-content">
                    <h3>Risk Mitigation</h3>
                    <p>
                      clearly defines the "Scope of Work" in the digital
                      agreement to avoid "scope creep" where clients expect
                      unlimited manual support for a flat fee.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <section className="key-flaws section">
        <Container>
          <Row>
            <Col md={5}>
              <div className="key-flaws-img">
                <img
                  src={Keyflaws}
                  alt="Why werentt for buy sell and rent property"
                />
              </div>
            </Col>
            <Col md={7}>
              <div className="key-flwas-contnet">
                <div className="section-heading">
                  <h2>Key flaws</h2>
                </div>
                <ul className="flaws-content">
                  <li>
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                    Fixed fees may reduce agent incentive to negotiate for the
                    absolute highest sale price compared to percentage
                    commissions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />A
                    flat fee might be too high for a small plot and too low to
                    cover the complexities of a large commercial building.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                    Sellers may be hesitant to pay a flat fee upfront if the
                    property doesn't sell quickly; consider milestone-based
                    payments.
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
